import {configureStore} from "@reduxjs/toolkit";
import generatedMovieReducer from "./slices/generatedMovie"

export default configureStore({
  reducer: {
    movies: generatedMovieReducer,
  },
});

